module.exports = {
  header: {
    title: 'Loyalty Action',
    buttonCreate: 'Create',
  },
  table: {
    title: {
      index: 'NO',
      name: 'ACTION NAME',
      feature: 'APP FEATURE',
      annexActionId: 'ANNEX ACTION ID',
      action: 'ACTION',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Do you want to delete loyalty this feature?',
      update: 'Do you want to update loyalty this feature?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    name: 'Name Action',
    feature: 'Feature',
    countries: 'Country',
    ctaLink: 'Link',
    btnUpdateLoyaltyAction: 'Update',
    btnCreateLoyaltyAction: 'Create',
    annexActionId: 'Annex Action ID',
    createLoyaltyAction: 'Create Loyalty Action',
    updateLoyaltyAction: 'Update Loyalty Action',
  },
  validate: {
    nameBlank: 'Please input Name Action!',
    featureBlank: 'Please select Feature!',
    countryBlank: 'Please select Country',
    annexActionIDBlank: 'Please input Annex Action ID',
  },
  message: {
    success: {
      updateLoyalty: 'Loyalty action successfully updated.',
      createLoyalty: 'Loyalty action successfully created.',
      deleteLoyalty: 'Loyalty action successfully deleted.',
      closeLoyalty: 'Loyalty action successfully closed.',
    },
  },
  popup: {
    title: 'Confirm',
    okBtn: 'Yes',
    cancelBtn: 'No',
    delete: 'Are you sure you want to delete this card?',
    show: 'Are you sure you want to show this card?',
    hide: 'Are you sure you want to hide this card?',
    close: 'Are you sure you want to close this card?',
    confirmPassword: 'Please input your password to confirm.',
    edit: 'Are you sure you want to edit this card?',
  },
};
